module.exports = __webpack_public_path__ + "img/pro-img1.74d603af.png";